export default "__VITE_ASSET__DhUAHLNv__"